import { apiClient } from '../../../utils/axios';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';

export const fetchShopifyLogs = async (query) => {
  const { data } = await apiClient.get(`/shopify-oauth/${query.queryKey[1].shopId}/logs`, {
    params: query.queryKey[1],
  });
  return data;
};

export const useGetShopifyLogsHandler = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [logs, setLogs] = useState([]);
  const [totalLogs, setTotalLogs] = useState(0);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ['shopify-logs', { ...searchQuery }],
    queryFn: fetchShopifyLogs,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    cacheTime: 0,
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setLogs(fetchedData.logs);
      setTotalLogs(fetchedData.totalLogs);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return { logs, totalLogs, isLoading, refetch, isFetching };
};
